<template>
  <div id="productIntroduction" style="background-color: #F4F6F8;min-height: 905px">
    <div class="productBack">
      <div style="width: 1280px;text-align: left;display: inline-block">
        <div class="title">更新说明
        <div class="downBtn" @click="downloadPdf">PDF文件</div>
        </div>
        <div class="subTitle">
          PKPM-CAE 每季度至少发布一个版本。以2026年为例，2025年底发布2026R1版，随后在2026年3月底、6月底、9月底分别发布2026R2、2026R3和2026R4版。
        </div>
      </div>
    </div>
    <div class="main">
        <div class="content">
          <div style="width: 100%" v-if="imgList.length!==0" v-for="(item,index) in imgList">
            <div>
              <img :src="item.uri" alt="" style="width: 100%;height: 100%">
            </div>
          </div>
        </div>
    </div>


  </div>


</template>

<script>
import axios from 'axios'
import {getCmsList, listCategory, searchFiles, listRelationFiles} from '../api/index'
import utils from '../lib/utils'

export default {
  name: "updateNote",
  data() {
    return {
      // categoryList: [],
      // nowCate: '',
      // imgCates: [],
      categoryId:'',
      imgList: [],


    }
  },


  methods: {

    getCategoryList() {
      let data = {
        type: 'intro',
      }
      listCategory(data).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          this.categoryList = res.data.result.categorys
          this.categoryList.forEach((item) => {
            item.showChildren = false
          })
          //临时处理
          const lastElement = this.categoryList[0].children.pop();
          this.categoryList[0].children.unshift(lastElement);

          this.categoryId=this.categoryList[0].children[0].id
          this.getContent()
        }
      }).catch((error) => {
        console.log(error);
      });
    },

    // choseCate(level, cat, num) {
    //   this.nowCate = cat
    //   if (cat.name === '软件简介') {
    //     this.imgCates = []
    //     this.imgList = []
    //     this.getVideo()
    //   } else {
    //     if (level === 1) {
    //       cat.showChildren = !cat.showChildren
    //       this.$set(this.categoryList, num, cat)
    //     } else if (level === 2) {
    //       listCategory({
    //         type: 'intro',
    //         pid: cat.id
    //       }).then((res) => {
    //         if (!res.data.result.success) {
    //           this.$Message.error(res.data.result.info);
    //         } else {
    //           this.imgCates = []
    //           this.imgList = []
    //           this.imgCates = res.data.result.categorys
    //           // console.log(this.imgCates)
    //           // this.getVideos()
    //           this.getVideo()
    //           console.log(this.imgList)
    //         }
    //       }).catch((error) => {
    //         console.log(error);
    //       });
    //     }
    //   }
    //
    // },
    //
    // getVideos() {
    //   this.imgList = []
    //   this.imgCates.forEach((item, index) => {
    //     searchFiles({
    //       type: 'intro',
    //       categoryId: item.id
    //     }).then((res) => {
    //       if (!res.data.result.success) {
    //         this.$Message.error(res.data.result.info);
    //       } else {
    //         this.$set(this.imgList, index, res.data.result.cmsFiles)
    //         if (this.imgList[index].length !== 0) {
    //           this.imgList[index].forEach((ids, ind) => {
    //             ids.uri = utils.handleHttps(ids.uri)
    //             ids.imgUri = utils.handleHttps(ids.imgUri)
    //             ids.prog = 0
    //           })
    //         }
    //         console.log(this.imgList)
    //       }
    //     }).catch((error) => {
    //       console.log(error);
    //     });
    //   })
    // },
    getContent() {
      searchFiles({
        type: 'intro',
        tag:'helpBook',
        categoryId: this.categoryId
      }).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          this.imgList = res.data.result.cmsFiles
          // this.$set(this.imgList, 0, res.data.result.cmsFiles)
          if (this.imgList.length !== 0) {
            this.imgList.forEach((item, index) => {
              item.uri = utils.handleHttps(item.uri)
              item.imgUri = utils.handleHttps(item.imgUri)
              item.prog = 0
              item.showProg = false
            })
          }
          console.log(this.imgList)
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    downloadPdf(){
      searchFiles({
        type: 'intro',
        tag:'pdf',
        categoryId: this.categoryId
      }).then((res) => {
        if (!res.data.result.success) {
          this.$Message.error(res.data.result.info);
        } else {
          let url=utils.handleHttps(res.data.result.cmsFiles[0].uri)
          window.open(url)
        }
      }).catch((error) => {
        console.log(error);
      });
    },


  },
  mounted() {
    window.scrollTo(0, 0)
    this.categoryId = this.$route.query.id
    if(this.categoryId===undefined){
      this.getCategoryList()
    }else{
      this.getContent()
    }
    console.log(this.categoryId)


    // this.getCategoryList()
    // this.getVideoList()
    // this.getImgList()
  }
}
</script>

<style scoped lang="scss">
.productBack {
  width: 100%;
  height: 280px;
  background: url("../../static/img/updateNote/updateNote.png");
  text-align: center;

  .title {
    font-weight: 600;
    font-size: 32px;
    color: #FFFFFF;
    margin-top: 118px;
  }

  .subTitle {
    width: 60%;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
    margin-top: 8px;
  }
}
.main{
  text-align: center;
  padding-top: 32px;
  padding-bottom: 36px;
  .content{
    text-align: left;
    display: inline-block;
    width: 1280px;
  }
}
.downBtn{
  display: inline-block;
  height: 30px;
  width: 100px;
  border: 1px solid white;
  border-radius: 5px;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  line-height: 28px;
  cursor: pointer;
  position: relative;
  top: -5px;
}

//.categories {
//  position: fixed;
//  display: inline-block;
//  width: 200px;
//  background-color: white;
//  border-radius: 2px;
//  padding: 25px;
//  margin-right: 15px;
//
//  .one {
//    margin-bottom: 25px;
//    font-size: 16px;
//    color: #333333;
//    font-weight: 800;
//    cursor: pointer;
//  }
//
//  .two {
//    margin-bottom: 25px;
//    font-size: 14px;
//    color: #666666;
//    font-weight: 500;
//    margin-left: 20px;
//    cursor: pointer;
//  }
//
//
//}
//
//.choseCate {
//  color: #1175EB !important;
//}
//
//.content {
//  display: flex;
//  width: 1200px;
//  margin: 0 auto;
//  min-height: 830px;
//  padding-bottom: 45px;
//  padding-top: 100px;
//
//  .block {
//    border-radius: 4px;
//    position: relative;
//    display: inline-block;
//    width: 300px;
//    border: 1px solid #EFEFEF;
//    margin: 0 10px 30px 15px;
//
//    &:hover {
//      box-shadow: 5px 5px 5px rgba(239, 239, 239, 1);
//      color: #1175EB;
//
//
//    }
//
//    .videoArea {
//      /*font-size: 20px;*/
//      /*line-height: 200px;*/
//      overflow-y: hidden;
//      height: 170px;
//      width: 300px;
//      cursor: pointer;
//    }
//
//    .textArea {
//      height: 50px;
//      background: #FFFFFF;
//      border-radius: 0 0 4px 4px;
//      padding: 15px;
//      width: 300px;
//
//      .cont {
//        display: inline-block;
//        width: 80%;
//        /*width: 100%;*/
//        white-space: nowrap;
//        overflow: hidden;
//        text-overflow: ellipsis;
//      }
//
//      .progClass {
//        bottom: 0;
//        left: 15px;
//        position: absolute;
//      }
//    }
//
//  }
//}
//
//@media (max-width: 1440px) {
//  .content {
//    width: 920px;
//  }
//  .categories {
//    left: 5px;
//  }
//}
</style>



// WEBPACK FOOTER //
// src/components/updateNote.vue